// store/modules/dropdown.js
import Service from "@/service/api";

export default {
    namespaced: true,

    state: {
        roles: [],
        statuses: [],
        types: [],
    },

    mutations: {
        SET_ROLES(state, data) {
            state.roles = data;
        },
        SET_STATUSES(state, data) {
            state.statuses = data;
        },
        SET_TYPES(state, data) {
            state.types = data;
        },
    },

    actions: {
        async fetchRoles({ commit }) {
            const res = await Service.roles("get");
            commit("SET_ROLES", res.data.data || []);
        },
        async fetchStatuses({ commit }) {
            const res = await Service.status("get");
            commit("SET_STATUSES", res.data.data || []);
        },
        async fetchTypes({ commit }) {
            const res = await Service.type("get");
            commit("SET_TYPES", res.data.data || []);
        },

        async fetchAllDropdowns({ dispatch }) {
            await Promise.all([
                dispatch("fetchRoles"),
                dispatch("fetchStatuses"),
                dispatch("fetchTypes"),
            ]);
        },
    },

    getters: {
        formattedRoles: (state) =>
            state.roles.map((item) => ({
                label: item.role_name,
                value: item.role_name
            })),
        formattedStatuses(state) {
            return state.statuses.map(s => ({
                label: s.status_name,
                value: s.status_name
            }))
        },
        formattedTypes(state) {
            return state.types.map(t => ({
                label: t.type_name,
                value: t.type_name
            }))
        }
    },
};
